import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';
import pointsMarkup from '../markup2/posters.js';
import toolsMarkup from '../markup/tools.js';
import cropWrap from '../tools/cropWrapper.js';

const loaderSpinnerId = 'loader-enterprises';
const loaderSpinnerMessage = 'Загрузка';
const loaderSpinnerMarkup = toolsMarkup.getLoadSpinner(loaderSpinnerId, loaderSpinnerMessage);

const body = document.querySelector('body');
const formAdd = body.querySelector('#modal_one_txt_only');
const form = formAdd.querySelector('#modal_one_txt_only-form');
const name = form.querySelector('#modal_one_txt_only-name');
const addName = form.querySelector('#modal_one_txt_only-txt');
const cardTitle = document.querySelector('#modal_one_txt_only-title');
const addNameSubmitButton = form.querySelector('#modal_one_txt_only-submit');
import modalInfo from '../lk-catalogs/modal_one_txt_only.js';

const cardPosters = document.querySelector('#posters_card');
const cardPostersName = cardPosters.querySelector('#posters_card-name');
const cardPostersDesc = cardPosters.querySelector('#posters_card-desc');
const cardPostersAddChange = cardPosters.querySelector('button[name=submit]');
const cardPostersAddRemove = cardPosters.querySelector('button[name=remove]');
const cardPostersUploadNewImage = cardPosters.querySelector('#posters_card_image-uploader');
const cardPostersUploadNewImageElem = cardPosters.querySelector('#posters_card_image-uploader-Elem');


const cardPosterssecondBlock = cardPosters.querySelector('div[name=secondBlock]');

const mainTabPane = document.querySelector('#posters');
const mainTabPaneBTAdd = mainTabPane.querySelector('button[name=add]');
const mainTabPaneBTReload = mainTabPane.querySelector('button[name=refresh]');
const mainTabPaneBody = mainTabPane.querySelector('div[name=body]');

const cropWrapNode1 = cardPosters.querySelector('#image-uploader-wrapper');
const cardPhotoSpinner = cardPosters.querySelector('#uploadSpinner');

const menuBt =  document.querySelector('#MenuPosters');

let imageToUpload1 = null;

cropWrap.init(cropWrapNode1, false, {
  dataName: 'none',
  // aspectRatio: 3496/4962  ,
  onSave: (blob) => {
    imageToUpload1 = blob;
    sentPhoto();
  },
  onDelete: () => {
    imageToUpload1 = true;
    deletePhoto();
  }
});

const sentPhoto = () => {
  cardPhotoSpinner.style.opacity = 1;

  xhr.request = {
    metod: 'POST',
    url: `posters/${cardPosters.getAttribute('currentPoster')}/photo/`,
    // url: `imgSaver`,
    data: imageToUpload1,
    callbackSuccess: (answer) => onSaveComplite(answer)
  };
};

const onSaveComplite = (answer) => {
  getPoints();
  // console.log(answer);
  if(answer && answer.data) {
    cardPosters.setAttribute('currentPoster',  parseInt(answer.data));
  }
  cardPhotoSpinner.style.opacity = 0;
};

function deletePhoto() {
  xhr.request = {
    metod: 'DELETE',
    url: `jury/${currentArbitor}/photo`,
    data: '',
    callbackSuccess: cleanImg
  };
};

function cleanImg() {
  alert('очистить картинку');
  // cardArbitorsPhoto.src = 'https://cdn1.iconfinder.com/data/icons/hipster-4/512/hipster-fashion-style-beard-man-glasses-512.png';
}


const onSuccessPointsLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {

    $(cardPosters).modal('hide');
    // console.log(loadedPoints);
    pointsMarkup.drawDataInContainer(loadedPoints.data);
  } else {
    pointsMarkup.drawMarkupInContainer(`<p>${loadedPoints.message}</p>`);

  }
};

mainTabPaneBTReload.addEventListener('click', function () {
  getPoints();
});

mainTabPaneBTAdd.addEventListener('click', function () {

    cropWrapNode1.querySelector('.hover-hidden-wrapper').classList.add('hover');
    cardPosterssecondBlock.classList.add('divDisabled');
    cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;;
    cardPhotoSpinner.style.opacity = 0;
    cardPostersAddChange.innerHTML = 'Добавить';
    cardPosters.setAttribute('currentPoster', -1);
    // if (loadedPoints.data.image.length > 2) {
      // let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/posters/${loadedPoints.data.image}.jpg`;
      // let path = `http://festappbuilder.ru/content/festival/${auth.data.currentFestival}/posters/${loadedPoints.data.image}.jpg`;
      // cardPostersPhoto.src = path;
      cropWrap.setImg(cropWrapNode1, '');
    // }
    cardPostersName.value = '';
    cardPostersDesc.value = '';
    $(cardPosters).modal('show');
});

mainTabPaneBody.addEventListener('click', function (evt) {
  // определить тип на что нажали

  if (evt.target.attributes.pID) {
    cardPosters.setAttribute('currentPoster', evt.target.attributes.pID.nodeValue);
    clearCard();
    xhr.request = {
      metod: 'GET',
      url: `posters/${cardPosters.getAttribute('currentPoster')}`,
      data: ``,
      callbackSuccess: onSuccessCardLoad

    };
  }
});

function clearCard() {
  // cardPostersPhoto.src = 'https://cdn1.iconfinder.com/data/icons/hipster-4/512/hipster-fashion-style-beard-man-glasses-512.png';
  cardPostersName.value = '';
  cardPostersDesc. value = '';

}
const getPoints = () => {
  pointsMarkup.cleanContainer();
  pointsMarkup.drawMarkupInContainer(loaderSpinnerMarkup);

  xhr.request = {
    metod: 'GET',
    url: 'posters',
    data: '',
    callbackSuccess: onSuccessPointsLoad
  };
};


function forEach(data, callback) {
  for (let key in data) {
    if (data.hasOwnProperty(key)) {
      callback(key, data[key]);
    }
  }
}

function generateID(length) {

  let text = '';
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}



const onSuccessCardLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    // $(formAdd).modal('hide');

    cardPhotoSpinner.innerHTML = loaderSpinnerMarkup;;
    cardPhotoSpinner.style.opacity = 0;
    cardPostersAddChange.innerHTML = 'Изменить';

    if (loadedPoints.data.image && loadedPoints.data.image.length > 2) {
      let path = `${window.appSettings.xhrSettings.urlContentFest}${auth.currentFestival}/img/posters/${loadedPoints.data.image}.jpg`;
      // let path = `http://festappbuilder.ru/content/festival/${auth.data.currentFestival}/posters/${loadedPoints.data.image}.jpg`;
      // cardPostersPhoto.src = p
      cropWrap.setImg(cropWrapNode1, path);
    }
    cardPostersName.value = loadedPoints.data.creator;
    cardPostersDesc.value = loadedPoints.data.desc;
    // console.log(loadedPoints.data);

    cardPosterssecondBlock.classList.remove('divDisabled');
    $(cardPosters).modal('show');

  }
};
cardPostersAddChange.addEventListener('click', function () {

  // if (parseInt(cardPosters.getAttribute('currentPoster'), 10) == -1){
  //   xhr.request = {
  //     metod: 'POST',
  //     url: `posters/`,
  //     data: `creator=${cardPostersName.value}&desc=${cardPostersDesc.value}`,
  //     callbackSuccess: onSuccessAddLoad
  //   };
  // } else 
    xhr.request = {
      metod: 'PUT',
      url: `posters/${cardPosters.getAttribute('currentPoster')}`,
      data: `creator=${cardPostersName.value}&desc=${cardPostersDesc.value}`,
      callbackSuccess: onSuccessAddLoad
    };
});

const onSuccessAddLoad = (loadedPoints) => {
// document.querySelector(`#${loaderSpinnerId}`).remove();
  if (loadedPoints.status === 200) {
    $(cardPosters).modal('hide');
    getPoints();
  }
};

cardPostersAddRemove.addEventListener('click', function () {
  if(confirm('Вы уверены, что хотите удалить плакат?')){
    xhr.request = {
      metod: 'DELETE',
      url: `posters/${cardPosters.getAttribute('currentPoster')}`,
      data: '',
      callbackSuccess: onSuccessPointsLoad
    };
  }
});


export default {

  start() {
    // getPoints();
      menuBt.addEventListener('click', getPoints);
  },

  redraw: getPoints,

  stop() {
    pointsMarkup.cleanContainer();
    menuBt.removeEventListener('click', getPoints);
  }
};
